
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js??ref--9!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			});
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/attending/index.js
// module id = null
// module chunks = 